import React from "react";

export default function ManufacturedProductEventItem({ event, onClick }) {
  return (
    <div
      className="flex items-center justify-between text-xs"
      onClick={onClick}
    >
      <div className="truncate">
        <div className="font-small">{event.product_name}</div>
        <div className="text-xs text-gray-500">{event.new_lot_number}</div>
      </div>
      <div className="ml-2 text-xs">
        <span className="px-2 py-0.5 bg-gray-100 rounded">{event.time}</span>
      </div>
    </div>
  );
}
